import React, { Component, lazy } from "react"
import { Route, Switch } from "react-router-dom"
import { connect } from 'react-redux'
import Navigator from "../_CustomPages/Video09/Video09Navigator"
import ChatPage from "@/_CustomPages/Video09/ChatPage"
const Home = lazy(() => import('@/_CustomPages/Video09/Video09Home'))
const Payment = lazy(() => import('@/_CustomPages/Video09/Video09Payment/Video09Payment'))
const Order = lazy(() => import('@/_CustomPages/Video09/Video09Order/Video09Order'))
const OrderCheck = lazy(() => import('@/_CustomPages/Video09/Video09OrderCheck/Video09OrderCheck'))
const OrderDetail = lazy(() => import('@/_CustomPages/Video09/Video09OrderDetail/Video09OrderDetail'))
const OrderComplete = lazy(() => import('@/_CustomPages/Video09/Video09OrderComplete/Video09OrderComplete'))
const Footer = lazy(() => import('@/_CustomPages/Video09//Video09Footer'))

class Video09 extends Component {

    componentDidMount() {
        const link = document.getElementById("favicon")
        link.href = "https://front.videomonster.com/images-7cuytg20/web/video09/video09-favicon.svg"
    }

    listenLocationChange = (props) => { this.props.listenLocationChange(props) }

    render() {
        const { isMobile } = this.props
        const { pathname } = window.location

        return (
            <>
                {
                    pathname !== '/chat' &&
                    <Navigator />
                }
                <Switch>
                    <Route
                        exact
                        path="/"
                        component={props => {
                            this.listenLocationChange(props)
                            return <Home
                                {...props}
                                isMobile={isMobile}
                            />
                        }}
                    />
                    <Route
                        path="/home"
                        component={props => {
                            this.listenLocationChange(props)
                            return <Home
                                {...props}
                                isMobile={isMobile}
                            />
                        }}
                    />
                    <Route
                        path="/payment"
                        component={props => {
                            this.listenLocationChange(props)
                            return <Payment
                                {...props}
                                isMobile={isMobile}
                            />
                        }}
                    />
                    <Route
                        path="/order"
                        component={props => {
                            this.listenLocationChange(props)
                            return <Order
                                {...props}
                                isMobile={isMobile}
                            />
                        }}
                    />
                    <Route
                        path="/check"
                        component={props => {
                            this.listenLocationChange(props)
                            return <OrderCheck
                                {...props}
                                isMobile={isMobile}
                            />
                        }}
                    />
                    <Route
                        path="/detail"
                        component={props => {
                            this.listenLocationChange(props)
                            return <OrderDetail
                                {...props}
                                isMobile={isMobile}
                            />
                        }}
                    />
                    <Route
                        path="/complete"
                        component={props => {
                            this.listenLocationChange(props)
                            return <OrderComplete
                                {...props}
                                isMobile={isMobile}
                            />
                        }}
                    />
                    <Route path="/chat" component={props => <ChatPage {...props} />} />
                </Switch>
                {
                    (pathname === '/' || pathname === '/home') &&
                    <Footer {...this.props} />
                }
            </>
        )
    }
}

const mapStateToProps = state => ({
})

export default connect(
    mapStateToProps,
    null
)(Video09)